export const getAppointmentId = () => {
  const { pathname } = window.location;
  const match = pathname.match(/paperwork\/([a-zA-Z0-9-]+)/);

  if (match && Array.isArray(match)) {
    const [_, uuid] = match;

    return uuid;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/utils/paperwork/getAppointmentId.js